import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';

import {
  editTextReset,
  //
  editColor,
  editContents,
  editFontFamily,
  editFontSize,
  editFontWeight,
  editPreFontSize,
  editSubTitle,
  editText,
  editTextAlign,
  editTitle
} from 'src/store/modules/editText';
import {
  buttonsReset,
  editBtnBgColor,
  editBtnColor,
  editBtnFontFamily,
  editBtnFontSize,
  editBtnFontWeight,
  editBtnPreFontSize,
  editBtnRadius,
  editBtnText,
  editBtnTextAlign
} from 'src/store/modules/buttons';
import {
  imageReset,
  //
  editBg,
  editBgColor,
  editBgImage,
  editBgImageBlur,
  editRadius,
  editCurrentIndex,
  editDeeplink
} from 'src/store/modules/imageUpload';
import { pagesReset } from 'src/store/modules/pages';

import setInitValue from 'src/utils/setInitValue';
import { zeroPad } from 'react-countdown';
import { changeText } from 'src/utils/changeText';
import { changeEnter } from 'src/utils/changeEnter';
import { initTrackingValues } from '../TemplateTracking/BasicFullCountdownTracking';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';

let today = new Date();

const initViewValues = {
  bg: 'image',
  bgColor: { background: '#333333' },
  bgImage: {
    background:
      'https://image.inappmessage.com/sample/defaultGRAYLONGIMAGE.webp'
  },
  deeplink: { background: 'https://www.inappmessage.com/' },
  radius: { image_radius: 0, button: 0 },

  text: {
    year_title: '2024',
    title: 'BLACK FRIDAY',
    sub_title: 'UP TO 80% SALE only 24 hours!',
    countdown_title: 'Remaining Time',
    countdown: {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      date: today.getDate() + 1,
      hour: 0,
      min: 0,
      sec: 0
    }
  },
  fontSize: {
    year_title: 1,
    title: 2,
    sub_title: 1,
    countdown_title: 1,
    countdown: 3.5
  },
  fontWeight: {
    year_title: 500,
    title: 700,
    sub_title: 400,
    countdown_title: 400,
    countdown: 700
  },
  color: {
    year_title: '#ffffff',
    title: '#ffffff',
    sub_title: '#ffffff',
    countdown_title: '#ffffff',
    countdown: '#ffffff'
  },
  fontFamily: {
    year_title: 'Montserrat',
    title: 'Montserrat',
    sub_title: 'Montserrat',
    countdown_title: 'Montserrat',
    countdown: 'Montserrat'
  },
  textAlign: {
    year_title: 'center',
    title: 'center',
    sub_title: 'center',
    countdown_title: 'center',
    countdown: 'center'
  },

  btnText: { button: 'SHOW NOW' },
  btnFontSize: { button: 1 },
  btnFontWeight: { button: 500 },
  btnColor: { button: '#ffffff' },
  btnBgColorR: { button: 0 },
  btnBgColorG: { button: 0 },
  btnBgColorB: { button: 0 },
  btnBgColorA: { button: 1 },
  btnFontFamily: { button: 'Montserrat' },
  btnTextAlign: {
    button: 'center'
  }
};

const FullCountdown: FC = () => {
  const dispatch = useDispatch();
  const [currentUser, setCurrentUser] = useState('');

  useEffect(() => {
    async function getUserId() {
      const current = await Auth.currentUserInfo();
      setCurrentUser(current.attributes['custom:Company']);
    }
    getUserId();
  }, []);

  let clientName = useSelector((state: RootState) => state.client.userCompany);
  let templateWidth = useSelector((state: any) => state.template.templateWidth);
  let templateHeight = useSelector(
    (state: any) => state.template.templateHeight
  );
  let bg = useSelector((state: RootState) => state.imageUpload.bg);
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  let btnTextAlign = useSelector(
    (state: RootState) => state.buttons.btnTextAlign
  );
  const yearTitleFontURL = getFontURL(fontFamily?.year_title);
  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const countdownTitleFontURL = getFontURL(fontFamily?.countdown_title);
  const countdownFontURL = getFontURL(fontFamily?.countdown);
  const btnFontURL = getFontURL(btnFontFamily?.button);

  // const yearTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.year_title}`;
  // const titleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.title}`;
  // const subTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.sub_title}`;
  // const countdownTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.countdown_title}`;
  // const countdownFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.countdown}`;
  // const btnFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.button}`;

  const closeImageUrl = 'https://i.ibb.co/xC9Gcwb/Frame-6.png';
  const style = `
  @font-face {
    font-family: 'yearTitleFont';
    src: url(${yearTitleFontURL});
    }
  @font-face {
    font-family: 'titleFont';
    src: url(${titleFontURL});
    }
  @font-face {
    font-family: 'subTitleFont';
    src: url(${subTitleFontURL});
    }
  @font-face {
    font-family: 'countdownTitleFont';
    src: url(${countdownTitleFontURL});
    }
  @font-face {
    font-family: 'countdownFont';
    src: url(${countdownFontURL});
    }

  @font-face {
    font-family: 'btnFont';
    src: url(${btnFontURL});
    }
    a {
      color: #000000;
      text-decoration: none;
      cursor: pointer;
    }

    .root_view {
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };
      width: 100%;
      height: 100%;

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;

      .content_wrapper {
        width: 100%;
        height: 100%;
        padding: 0 10%;
      }

      .close_btn {
        position: absolute;
        right: 10%;
        top: 6%;
      }
      .close_btn button {
        width: 1.5rem;
        height: 1.5rem;
        
        background-image: url(${closeImageUrl});
        background-repeat: no-repeat;
        background-size: 1.5rem;
        background-position: center;

        font-size: 0;
        border: none;
        background-color: transparent;
      }
      
      .center {
        width: 100%;
        height: 100%;
        
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
      }

      .title_wrapper {
        width: 100%;
        display: flex;

        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
      }
      .title_wrapper .year {
        width: 100%;
        height: 1.25rem;
        text-align: ${textAlign?.year_title};

        font-size: ${fontSize?.year_title}rem;
        font-weight: ${fontWeight?.year_title};
        color: ${color?.year_title};
        
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.year_title
          )
            ? fontFamily?.year_title
            : 'yearTitleFont'
        } !important;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .title_wrapper .title {
        width: 100%;
        height: 3rem;
        text-align: ${textAlign?.title};
        
        font-size: ${fontSize?.title}rem;
        font-weight: ${fontWeight?.title};
        color: ${color?.title};
        
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.title
          )
            ? fontFamily?.title
            : 'titleFont'
        } !important;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .title_wrapper .sub_title {
        width: 100%;
        height: 4rem;
        text-align: ${textAlign?.sub_title};

        font-size: ${fontSize?.sub_title}rem;
        font-weight: ${fontWeight?.sub_title};
        color: ${color?.sub_title};
        
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.sub_title
          )
            ? fontFamily?.sub_title
            : 'subTitleFont'
        } !important;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
      }

      .timer_area {
        width: 100%;
        display: flex;

        flex-direction: column;
        gap: 0.5rem;
      }
      .timer_area .countdown_text {
        width: 100%;
        height: 1.5rem;
        text-align: ${textAlign?.countdown_title};

        font-size: ${fontSize?.countdown_title}rem;
        font-weight: ${fontWeight?.countdown_title};
        color: ${color?.countdown_title};
        
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            fontFamily?.countdown_title
          )
            ? fontFamily?.countdown_title
            : 'countdownTitleFont'
        } !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .timer_area .timer {
        height: 6.25rem;

        display: grid;
        grid-template-columns: 1fr 1rem 1fr 1rem 1fr;
        justify-content: space-between;
      }
      .timer_area li {
        list-style: none;
        text-align: ${textAlign?.countdown};

        font-size: ${fontSize?.countdown}rem;
        font-weight: ${fontWeight?.countdown};
        color: ${color?.countdown};
        font-family: ${fontFamily?.countdown} !important;

      }
      .timer_area .en {
        display: block;
        font-size: 1.25rem;
        font-weight: 400;
        font-family: ${fontFamily?.countdown} !important;
      }
      .timer_area .finish_ment {
        height: 5rem;

        display: flex;
        justify-content: center;
        align-items: center;

        color: #fff;
        white-space: pre-line;
        font-size: 1.25rem;
      }

      .btn_bottom {
        width: 100%;
        padding: 0 10%;
        position: absolute;
        left: 0;
        bottom: 2rem;
      }
      .btn_bottom button {
        width: 100%;
        height: 3rem;
        padding: 0 1rem;
        border: none;
        display: block;
        text-align: center;
      }
      .btn_bottom .style01 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        cursor: pointer;
        font-size: ${btnFontSize?.button}rem;
        font-weight: ${btnFontWeight?.button};
        color: ${btnColor?.button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
            btnFontFamily?.button
          )
            ? btnFontFamily?.button
            : 'btnFont'
        } !important;

        border-radius: ${radius?.button}px;
        background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
      }

      ${
        templateWidth > 767
          ? `
        .content_wrapper {
          padding: 0 25%;
        }
        .close_btn {
          right: 25%;
          top: 4rem;
        }

        .title_wrapper,
        .timer_area,
        .center {
          gap: 1rem;
        }
        .title_wrapper .year {
          height: 1.8125rem;
          font-size: ${fontSize?.year_title + 0.5}rem;
        }
        .title_wrapper .title {
          height: 4rem;
          font-size: ${fontSize?.title + 1}rem;
        }
        .title_wrapper .sub_title {
          height: 5rem;
          font-size: ${fontSize?.sub_title + 1}rem;
          -webkit-line-clamp: 2;
        }

        .timer_area .timer {
          height: 8.125rem;
        }
        .timer_area .countdown_text {
          height: 2rem;
          font-size: ${fontSize?.countdown_title + 0.5}rem;
        }
        .timer_area li {
          font-size: ${fontSize?.countdown + 1.5}rem;
        }

        .btn_bottom {
          padding: 0 25%;
          bottom: 4rem;
        }
        .btn_bottom button {
          height: 4rem;
        }
      `
          : ``
      }
    }
  `;

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          if (
            customValues?.bgImage &&
            customValues?.text &&
            customValues?.btnText
          ) {
            setInitValue(dispatch, customValues);
          } else {
            setValue(
              dispatch,
              customValues,
              { ...initViewValues, ...initTrackingValues },
              clientName
            );
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(imageReset());
      dispatch(editTextReset());
      dispatch(buttonsReset());
      dispatch(pagesReset());
      dispatch(trackingReset());
    };
  }, []);

  const [finish, setFinish] = useState(false);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    setFinish(false);
    const future = Date.parse(
      `${text?.countdown?.year}/${text?.countdown?.month}/${text?.countdown?.date} ${text?.countdown?.hour}:${text?.countdown?.min}:${text?.countdown?.sec}`
    );

    const interval = setInterval(() => {
      const now: any = new Date();
      const diff = future - now;
      if (diff <= 0 || isNaN(diff)) {
        setFinish(true);
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const mins = Math.floor(diff / (1000 * 60));
      const secs = Math.floor(diff / 1000);

      const d = days;
      const h = hours - days * 24;
      const m = mins - hours * 60;
      const s = secs - mins * 60;

      const date = h + d * 24;
      setHours(date);
      setMinutes(m);
      setSeconds(s);
    }, 1000);

    return () => clearInterval(interval);
  }, [text?.countdown]);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_view">
        <div className="content_wrapper">
          <div className="close_btn">
            <button>close</button>
          </div>

          <div className="center">
            <div className="title_wrapper">
              <p className="year">{changeEnter(text?.year_title)}</p>
              <p className="title">{changeEnter(text?.title)}</p>
              <p className="sub_title">{changeEnter(text?.sub_title)}</p>
            </div>

            <div className="timer_area">
              <p className="countdown_text">
                {changeEnter(text?.countdown_title)}
              </p>
              {finish ? (
                <div className="finish_ment">종료되었습니다.</div>
              ) : (
                <ul className="timer" id="timer">
                  <li>
                    {hours}
                    <span className="en">Hours</span>
                  </li>
                  <li className="margin">:</li>
                  <li>
                    {minutes}
                    <span className="en">Mins</span>
                  </li>
                  <li className="margin">:</li>
                  <li>
                    {seconds}
                    <span className="en">Secs</span>
                  </li>
                </ul>
              )}
            </div>
          </div>

          <div className="btn_bottom">
            <button className="style01">{btnText?.button}</button>
          </div>
        </div>
      </div>
    </>
  );
};

const setValue = (
  dispatch: any,
  values: any,
  initViewValuesss: any,
  clientName: any
) => {
  // console.log(values);
  // console.log('test');
  // if (values?.bgColor) dispatch(editBgColor(values?.bgColor));
  dispatch(
    editBgImage({
      background: `https://image.inappmessage.com/${clientName}/${values?.countdownbgImgName}`
    })
  );
  // if (values?.bgImageBlur) dispatch(editBgImageBlur(values?.bgImageBlur));
  dispatch(editDeeplink({ background: values?.countdownDeeplink }));
  // if (values?.radius) dispatch(editRadius(values?.radius));

  dispatch(
    editText({
      year_title: changeText(values?.titleYear),
      title: changeText(values?.titleText),
      sub_title: changeText(values?.subTitleText),
      countdown_title: changeText(values?.countdownTimerText),
      countdown: {
        year: values?.newYear,
        month: values?.newMonth,
        date: values?.newDate,
        hour: values?.newHour,
        min: values?.newMin,
        sec: values?.newSec
      }
    })
  );
  // dispatch(
  //   editPreFontSize({
  //     ...initViewValuesss?.fontSize,
  //     ...{
  //       year_title: values?.yearFontSize / 16,
  //       title: values?.titleFontSize / 16,
  //       sub_title: values?.subTitleFontSize / 16
  //       // countdown_title: values?.countdownCloseFontSize
  //     }
  //   })
  // );
  // dispatch(
  //   editFontSize({
  //     ...initViewValuesss?.fontSize,
  //     ...{
  //       year_title: values?.yearFontSize / 16,
  //       title: values?.titleFontSize / 16,
  //       sub_title: values?.subTitleFontSize / 16
  //       // countdown_title: values?.countdownCloseFontSize
  //     }
  //   })
  // );
  // dispatch(
  //   editFontWeight({
  //     ...initViewValuesss?.fontWeight,
  //     ...{
  //       year_title: values?.yearFontWeight,
  //       title: values?.titleFontWeight,
  //       sub_title: values?.subTitleFontWeight,
  //       countdown_title: values?.countdownTimerFontWeight
  //       // countdown: values?.countdownTimerFontWeight
  //     }
  //   })
  // );
  dispatch(
    editColor({
      ...initViewValuesss?.color,
      ...{
        year_title: values?.yearTextColor,
        title: values?.titleTextColor,
        sub_title: values?.subTitleColor,
        countdown_title: values?.countdownTimerColor
        // countdown: values?.countdownTimerFontWeight
      }
    })
  );
  // if (values?.fontFamily) dispatch(editFontFamily(values?.fontFamily));
  // if (values?.textAlign) dispatch(editTextAlign(values?.textAlign));

  dispatch(
    editBtnText({
      button: changeText(values?.fullCountdownBtnText)
    })
  );
  // dispatch(editBtnPreFontSize({ button: values?.countdownBtnFontSize / 16 }));
  // dispatch(editBtnFontSize({ button: values?.countdownBtnFontSize / 16 }));
  // dispatch(editBtnFontWeight({ button: values?.newBtnFontWeight }));
  dispatch(editBtnColor({ button: values?.newBtnTextColor }));
  dispatch(
    editBtnBgColor(
      { button: values?.BtnBgColorR },
      { button: values?.BtnBgColorG },
      { button: values?.BtnBgColorB },
      { button: values?.BtnBgColorA }
    )
  );
  // if (values?.btnFontFamily)
  //   dispatch(editBtnFontFamily(values?.btnFontFamily));
};

export default FullCountdown;
